import * as actions_assets from 'actions/assets-actions';
import * as actions_inventory from 'actions/inventory-actions';
import * as actions_profiles from 'actions/profiles-actions';
import * as actions_service_requests from 'actions/service-requests-actions';
import * as actions_users from 'actions/users-actions';
import * as toolbox from 'components/common/toolbox';
import Authorize from 'components/common/authorize';
import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { APPS, ADDRESSES, PERMISSIONS, ROLES } from 'components/constants';
import { Address, DashboardDetail, Ibox, Mapbox, Spinner } from 'enspire-manager-framework';
import { Contact } from 'components/common/contact';
import { Table } from 'em-table';
import { navMultipleUrls } from 'components/common/toolbox';
import { numPanels } from 'components/common/toolbox';
import { sortByPosition } from 'components/common/toolbox';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

export default function CustomerAccount(props) {
	
	/* Hooks -------------------------------------------------------------------------------------------------------------------*/
	
	const seg = 3;
	const params = useParams();
	const history = useHistory();
	const dispatch = useDispatch();
	const routeLocation = useLocation();
	const hasPageRendered = useRef(false);
	
	const assets = useSelector((store) => store.assets);
	const inventory = useSelector((store) => store.inventory);
	const profiles = useSelector((store) => store.profiles);
	const services = useSelector((store) => store.serviceRequests);
	const settings = useSelector((store) => store.settings.settings);
	const user = useSelector((store) => store.users.user);
	const user_permissions = useSelector(store => store.users?.user_permissions);
	
	const [mapAddress, setMapAddress] = useState();
	
	const profile = profiles.profile;
    const pathname = routeLocation.pathname;

    // Permissions ----------------------------------------

	const canCreate = user_permissions[PERMISSIONS.SERVICE_REQUESTS_CREATE.key];
	const canEdit = user_permissions[PERMISSIONS.CUSTOMERS_EDIT.key];

	/* Effects -----------------------------------------------------------------------------------------------------------------*/

	useEffect(() => {
		if (hasPageRendered.current) {
			let location = toolbox.modifyPath(routeLocation?.pathname, seg, null, 7);
			history.replace({ pathname: location });
		}
		hasPageRendered.current = true;
    }, [params.appId]);

	// Subscribe to Profile to complete address and contact information
	// useEffect(() => {
	// 	if (parseInt(params.customer_id)) dispatch(actions_profiles.subProfile(params.handle, params.customer_id, 'PROFILE'));
	// 	return () => {
	// 		let unsubscribe = profiles.profile_unsubscribe;
	// 		if (typeof unsubscribe === "function") unsubscribe();
	// 		dispatch(actions_profiles.clearProfile());
	// 		dispatch(actions_profiles.addressSelected(null));
	// 	};
		
	// }, [params.customer_id, profiles.contact_save_pending]);
		
	// Subscribe to Assets for this Customer
	useEffect(() => {
		if (params.appId == APPS.ASSETS.id) {
			dispatch(actions_assets.subAssets(params.handle, params.customer_id, settings?.features?.assets?.customer_assets));

			return () => {
				const unsubscribe = assets.assets_unsubscribe;
				if (typeof unsubscribe == 'function') unsubscribe();
			}
		}
	}, [params.customer_id, settings?.features?.assets?.customer_assets, params.appId]);

    useEffect(() => {
        dispatch(actions_service_requests.subServiceRequests(params.handle, params.customer_id));

        return () => {
            let unsubscribe = services.service_requests_unsubscribe;
            if (typeof unsubscribe === 'function') unsubscribe();
        };
    }, [params.customer_id, params.appId]);

	useEffect(() => {
		dispatch(actions_inventory.subInventoryByVendorId(params.handle, params.customer_id));

		return () => {
			const unsubscribe = inventory.inventory_unsubscribe;
			if (typeof unsubscribe == 'function') unsubscribe();
		};
	}, [params.customer_id]);

	useEffect(() => {
		let address = _.find(profile?.addresses, (o) => { return (
			o.addressTypeId == ADDRESSES.SERVICE.id || 
			o.addressTypeId == ADDRESSES.DELIVERY.id || 
			o.addressTypeId == ADDRESSES.PHYSICAL.id || 
			o.addressTypeId == ADDRESSES.MAILING.id
		)});
        let mapAddress = (address) ? `${address.addressLine1} ${address.addressLine2} ${address.city} ${address.state} ${address.zip}` : null;
		setMapAddress(mapAddress);
	}, [profile]);

	/* Handlers/Actions --------------------------------------------------------------------------------------------------------*/

	const startSR = (address, event) => {
		event?.stopPropagation();
		dispatch(actions_profiles.addressSelected(address));

		navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
			toolbox.modifyPath(pathname, seg+2, `form/0/service_requests`),
			toolbox.modifyPath( pathname, seg+2, `request-form/0/service_requests`)
		]});
	}
	const openAddressForm = (addressId) => {
		let location = toolbox.modifyPath(pathname, seg+2, `address-form/${addressId}`);
		history.push({ pathname: location });
	};
	const openContactForm = (contactId) => {
		let location = toolbox.modifyPath(pathname, seg+2, `contact-form/${contactId}`);
		history.push({ pathname: location });
	};
	const portalCallback = (contact, portalStatus) => {
		// create or enable/disable portal for this contact
		const customerRoleId = (params.appId == APPS.DISPATCH.id) ? ROLES.SERVICE_CUSTOMER : ROLES.ASSET_CUSTOMER.id;
		if (portalStatus) {
			dispatch(actions_users.createUser(params.handle, contact.email, contact.firstName, contact.lastName, params.customer_id, customerRoleId));
		} else {
			dispatch(actions_users.addRemoveUserRole(params.handle, contact.email, customerRoleId, false));
		}
	};
	const viewAssets = () => {
		dispatch(actions_assets.selectCustomer(params.handle, params.customer_id));
		let location = toolbox.modifyPath(pathname, seg, `assets`, seg);
		history.replace({ pathname: location });
	}

	/* Constants ---------------------------------------------------------------------------------------------------------------*/

	var contactArray = []; // start with all contacts, remove when assigned an address
	if (profile?.contacts)
		profile.contacts.forEach((contact) => {
			contactArray.push(contact);
		});

    const serviceAddresses = _.filter(profile?.addresses, { addressTypeId: ADDRESSES.SERVICE.id }).map((address) => {
		let addressArray = toolbox.format_address(address?.addressLine1, address?.addressLine2, address?.city, address?.state, address?.zip);
		return ({ ...address,
			addressName: (address.addressName) ? address.addressName : 'Service Address',
			address: addressArray.join(''),
		 });
	});

	const addresses = profile?.addresses ? profile?.addresses?.map((address, index) => {

        const addressType = _.find(Object.values(ADDRESSES), { id: address.addressTypeId });

		if (addressType.id == ADDRESSES.SERVICE.id) return null;
		
		return (
			<Ibox key={"address" + index}
				title={ <span><i className="fas fa-home"></i> &nbsp; {addressType?.name}</span> }
				mini={true}
				className={"animation-delay-" + index * 2}
				jsx={<Authorize perm={ PERMISSIONS.CUSTOMERS_EDIT }>
						<i className="fa-regular fa-gear pull-right text-muted mt-n1" onClick={() => openAddressForm(address.id)} role="button"></i>
					</Authorize>}
			>

				<Address address={address} />

				{profile?.contacts?.map((contact) => {
					if (address.contactIds?.includes(contact.id)) {
						contactArray = contactArray.filter(
							(item) => item.id !== contact.id
						); // remove from array
						return (
							<Contact {...props}
								key={address.id + contact.id}
								contact={contact}
								editCallback={(user_permissions.CUSTOMERS_EDIT) ? openContactForm : null}
								portalCallback={(user_permissions.CUSTOMERS_EDIT) ? portalCallback : null}
							/>
						);
					}
					return null;
				})}
			</Ibox>
		);
	}) : null;

	const additionalContacts = contactArray.map((contact) => {
		return (
			<Contact {...props}
				key={"addl" + contact.id}
				contact={contact}
				editCallback={(user_permissions.CUSTOMERS_EDIT) ? openContactForm : null}
				portalCallback={(user_permissions.CUSTOMERS_EDIT) ? portalCallback : null}
			/>
		);
	});

	/* Render ------------------------------------------------------------------------------------------------------------------*/

	return (
		<div className="row">
			{profile && parseInt(params.customer_id) ? (
				<>
					<div className="col-12 px-4">
						<h4 className="ml-2 mt-3">Account</h4>
						<div id="profile-details" className="mt-3 mb-4">
							{/* <DashboardDetail field={ 'Id' } value={ profile.id } /> */}
							<DashboardDetail field={ 'Company Name' } value={ profile.companyName } />
							<DashboardDetail field={ 'Phone' } value={ profile.phone } type="phone" />
							<DashboardDetail field={ 'Website' } value={ profile.website } type="url" />
							<DashboardDetail field={ 'Notes' } value={ profile.notes } />
						</div>

						<div className="row">
							<div className="col-xl-6 pt-3 px-2" style={{ backgroundColor: '#f3f3f4' }}>

								{ params.appId == APPS.ASSETS.id && 
									<button className="btn btn-info btn-sm mb-3" onClick={viewAssets}>
										<i className="fa-solid fa-truck-container fa-lg mr-2"></i>View Customer Assets
									</button>
								}
								{addresses}

								{ !!additionalContacts.length && (
									<Ibox key={profile.id}
										title={
											<span>
												<i className="fas fa-user"></i>{" "}
												&nbsp; Additional Contacts
											</span>
										}
										mini={true}
										className={ "animation-delay-" + addresses.length * 2 }
									>
										{additionalContacts}
									</Ibox>
								)}

								<button className="btn btn-default btn-sm float-left mx-2" type="button" 
									disabled={!user_permissions.CUSTOMERS_EDIT}
									onClick={() => openAddressForm(0)}>
									+ New Address
								</button>
								<button className="btn btn-default btn-sm float-left mx-2" type="button" 
									disabled={!user_permissions.CUSTOMERS_EDIT}
									onClick={() => openContactForm(0)}>
									+ New Contact
								</button>

								<div style={{ clear: 'both' }}></div>

								{ mapAddress &&
									<div className="mapbox-container img-thumbnail mt-3">
										<Mapbox map_address={ mapAddress } aspect_ratio={ 2 } className={ 'animation-delay-4 mb-2' } />
										{ mapAddress }
									</div>
								}

							</div>
							<div className="col-xl-6 pt-3 px-2" style={{ backgroundColor: '#f3f3f4' }}>
								{ !!serviceAddresses.length &&
									<>
										<Ibox
											title={ <span><i className="fa-solid fa-location-dot"></i> &nbsp; Service Addresses</span> }
											mini={true}
											className={"animation-delay-2"}
										>
											<Table
												data={serviceAddresses}
												show_limit={false}
												show_search={true}
												chevron={true}
												highlight_search={true}
												active_id={mapAddress}
												active_field={"address"}
												columns={[
													{ name: "Service Address", field: "addressName", width: (canCreate && canEdit) ? 70 : (canCreate) ? 80 : (canEdit) ? 90 : 100 },
													...(canCreate) ? [{ name: '', field: 'id', type: 'button', text_align: 'center', button: { name: <span className="nowrap">+ Service</span>, className: 'btn-secondary btn-xs', callback: startSR }, width: 20}] : [],
													...(canEdit) ? [{ name: '', field: 'id', type: 'button', text_align: 'center', button: { name: <i className="fa-regular fa-gear text-muted"></i>, className: 'btn-default btn-xs', callback: (address) => openAddressForm(address.id) }, width: 10}] : [],
													{ name: "Address", field: "address" },
												]}
												second_line={'address'}
												click_callback={(address) => {
													setMapAddress(address.address);
													dispatch(actions_profiles.addressSelected(address));
												}}
												order_by={{ fields: ['displayName'], direction: ['asc'] }}
											/>
										</Ibox>
									</>
								}
							</div>
						</div>
					</div>
				</>
			) : (
				<div className="col-12">
					<h2 className="text-center mb-4">Customer Unavailable</h2>
				</div>
			)}
		</div>
	);
}
